import React, { useState, useEffect } from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { Field, useField, useFormikContext } from "formik";
import { TODIS_FORM_FIELD_MULTISELECT, TODIS_FORM_FIELD, TODIS_FORM_FILE, TODIS_FORM_FIELD_YES_NO, TODIS_FORM_FIELD_DATE, TODIS_FORM_DSC, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID } from "../../../../components/Forms";
import { BsExclamationCircleFill } from "react-icons/bs";
import { AuxiliaryService } from "../../../../HttpService/AuxiliaryService";
import axios from "axios";

const TODIS_FORM_ACQUIS_LEGIS = (props) => {
        const { setFieldValue } = useFormikContext();
        const [sectors, setSectors] = useState([]);
        const [regulatoryAreas, setRegulatoryAreas] = useState([]);
        const [typeOfActs, setTypeOfActs] = useState([]);
        const [actionPlans, setActionPlans] = useState([]);
        const [transpositionStatuses, setTranspositionStatuses] = useState([]);
        const [regionals, setRegionals] = useState([]);
        const [file, setFile] = useState();

        const filechange = (event) => {
                setFieldValue("file", event.currentTarget.files[0]);
                setFile(event.currentTarget.files[0]);
        }

        const loadFile = () => {
                // let loadedFile = new File(["EU_Acquis_document.pdf"], "EU_Acquis_Document");
                // setFile(loadedFile);
                // setFieldValue("file", new File(["EU_Acquis_255.pdf"], "EU_Acquis_255.pdf"));
                //console.log("load file is called");
                const fileInput = document.getElementById("file");
                // fileInput.defaultValue = "EU_Acquis_255.pdf";
                // Create a new File object
                const myFile = new File(['EU_Acquis_' + props.requestId], 'EU_Acquis_' + props.requestId, {
                        // type: 'text/plain',
                        lastModified: new Date(),
                });

                // Now let's create a DataTransfer to get a FileList
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(myFile);
                fileInput.files = dataTransfer.files;
        }

        const downloadFile = async () => {
                const url = `https://todis.transport-community.org/api/data/download/file/225/EU-acquis`;
                const response = await axios.get(url);
                const filename = "EU_Acquis_255";
                if (response.status === 200) {
                        const blob = await response.data;
                        const objectURL = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = objectURL;
                        link.download = filename;
                        link.click();
                }
        }

        const getDataSelect = async () => {

                const query = await new AuxiliaryService('auxData/euacquis,regulatoryarea,regionalpartner,actionplans,euacquitype,transpositionstatus').getAuxiliaries();

                query.map((option, index) => {

                        if (option.txtNameTable == "euacquis")
                                setSectors(option.auxtableDetailsDTOList)
                        if (option.txtNameTable == "regulatoryarea")
                                setRegulatoryAreas(option.auxtableDetailsDTOList)
                        if (option.txtNameTable == "actionplans")
                                setActionPlans(option.auxtableDetailsDTOList);
                        if (option.txtNameTable == "euacquitype")
                                setTypeOfActs(option.auxtableDetailsDTOList);
                        if (option.txtNameTable == "transpositionstatus")
                                setTranspositionStatuses(option.auxtableDetailsDTOList)
                        if (option.txtNameTable == "regionalpartner")
                                setRegionals(option.auxtableDetailsDTOList)
                })
        }

        useEffect(() => {
                getDataSelect();
                //console.log("use effect", props);
                if (props.dataFromForm.tableConcordance)
                        loadFile()
        }, [props]);

        return (
                <>
                        <Col lg={12}>
                                <TODIS_FORM_DSC id="legislation" label="Legal Act" name="legislation" disabled={true} />
                                {props.errors.legislation && props.touched.legislation ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.legislation}</div>) : null}
                        </Col>
                        <Col lg={4}>
                                <TODIS_FORM_FIELD id="dateValidFor" label="Valid For" name="dateValidFor" disabled={true} />
                                {props.errors.dateValidFor && props.touched.dateValidFor ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.dateValidFor}</div>) : null}
                        </Col>
                        <Col lg={4}>
                                <TODIS_FORM_FIELD id="celexNumber" label="CELEX Number" name="celexNumber" disabled={true} />
                                {props.errors.celexNumber && props.touched.celexNumber ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.celexNumber}</div>) : null}
                        </Col>
                        <Col lg={4}>
                                <TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID id="sector" label="Sector" name="sector" options={sectors} disabled={true} value={props.sector} />
                                {props.errors.sector && props.touched.sector ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.sector}</div>) : null}
                        </Col>

                        <Col lg={4}>
                                <TODIS_FORM_FIELD id="regionalPartner" label="Regional Partners" name="regionalPartner" disabled={true} />
                                {props.errors.regionalPartner && props.touched.regionalPartner ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.regionalPartner}</div>) : null}
                        </Col>
                        {/* <Col lg={12}>
                                <TODIS_FORM_FIELD_MULTISELECT id="regionalPartner" label="REGIONAL PARTNER" name="regionalPartner" options={regionals} setFieldValue={setFieldValue} values={props.values} isLoading={false} disabled={true} />
                                {props.errors.regionalPartner && props.touched.regionalPartner ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {props.errors.regionalPartner}</div>) : null}
                        </Col> */}

                        <Col lg={4}>
                                <TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID id="regulatoryArea" label="Regulatory Area" name="regulatoryArea" options={regulatoryAreas} disabled={true} value={props.regulatoryArea} />
                                {props.errors.regulatoryArea && props.touched.regulatoryArea ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.regulatoryArea}</div>) : null}
                        </Col>
                        <Col lg={4}>
                                <TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID id="typeOfAct" label="Type Of Act" name="typeOfAct" options={typeOfActs} disabled={true} value={props.typeOfAct} />
                                {props.errors.typeOfAct && props.touched.typeOfAct ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.typeOfAct}</div>) : null}
                        </Col>
                        <Col lg={4}>
                                <TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID id="includedInTctActionPlans" label="Action Plan" name="includedInTctActionPlans" options={actionPlans} disabled={true} value={props.includedInTctActionPlans} />
                                {props.errors.includedInTctActionPlans && props.touched.includedInTctActionPlans ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.includedInTctActionPlans}</div>) : null}
                        </Col>
                        <Col lg={4}>

                                <TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID id="transpositionStatus" label="Transposition Status" name="transpositionStatus" options={transpositionStatuses} value={props.transpositionStatus} />
                                {props.errors.transpositionStatus && props.touched.transpositionStatus ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.transpositionStatus}</div>) : null}
                        </Col>
                        {props.dataFromForm.tableConcordance ?
                                <Col lg={4}>
                                        <TODIS_FORM_FILE id="file" label="Tables of concordance" name="file" filechange={filechange} />
                                        {props.errors.file && props.touched.file ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.file}</div>) : null}
                                        {/* <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{ margin: "0.5rem", float: "right" }} onClick={() => downloadFile()}>Download File </Button> */}
                                        <a href={`https://todis.transport-community.org/api/data/download/file/${props.requestId}/EU-acquis`}>Download File here</a>
                                </Col> :
                                <Col lg={4}>
                                        <TODIS_FORM_FILE id="file" label="Tables of concordance" name="file" filechange={filechange} />
                                        {props.errors.file && props.touched.file ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.file}</div>) : null}

                                </Col>
                        }
                        {/* <h1>{props.dataFromForm.tableConcordance}</h1> */}
                        <Col lg={12}>
                                <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" />
                                {props.errors.remarks && props.touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {props.errors.remarks}</div>) : null}
                        </Col>
                </>
        )
}

export default TODIS_FORM_ACQUIS_LEGIS;